export class AttendantCompaniesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAttendantCompanies() {
    return this.#http.get('/attendant-companies');
  }
}
